import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { formatScenarioDisplayHtml, formatScenarioEditorHtml } from "./formatScenarioHtml";

const EditScenarioModal = ({ isOpen, toggle, card, onSuccess }) => {
  const [scenarioName, setScenarioName] = useState("");
  const [script, setScript] = useState("");
  const [saving, setSaving] = useState(false);

  const editor = useEditor({
    extensions: [StarterKit],
    content: "",
    onUpdate({ editor }) {
      setScript(editor.getHTML());
    }
  });

  useEffect(() => {
    if (isOpen && card && editor) {
      setScenarioName(card.item_name || card.flash_card_name || "");
      const html = formatScenarioEditorHtml(card.format_coching_script || "");
      editor.commands.setContent(html || "");
      setScript(editor.getHTML());
    }
  }, [isOpen, card, editor]);

  const handleSave = () => {
    const name = scenarioName.trim();
    if (!name) {
      alert("Scenario name is required");
      return;
    }
    const formattedScript = formatScenarioDisplayHtml(script);
    if (!formattedScript.trim()) {
      alert("Scenario content is required");
      return;
    }

    setSaving(true);
    postDataAPI({
      serviceName: "item_data",
      op: "create_update_scenario",
      flash_id: card.flash_id,
      scenario_name: name,
      coching_script: formattedScript
    })
      .then((res) => {
        if (res.status === "ok") {
          onSuccess?.();
          toggle();
        } else {
          alert(res.message || "Failed to update scenario");
        }
      })
      .finally(() => setSaving(false));
  };

  if (!card) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>Edit Scenario</ModalHeader>

      <ModalBody>
        <Label>Scenario Name</Label>
        <Input
          value={scenarioName}
          onChange={(e) => setScenarioName(e.target.value)}
          className="mb-3"
        />

        <Label>Scenario Flashcard</Label>
        <EditorContent
          editor={editor}
          className="border rounded p-2 mb-0 scenario-editor"
          style={{ minHeight: 180 }}
        />
      </ModalBody>

      <ModalFooter>
        <Button outline onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Save Changes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditScenarioModal;
